import axios from 'axios'
import { triggerLogoutHandler } from '@/services/auth-events'
import { toast } from 'sonner'
import { getAccessToken, clearAuthStorage } from '@/services/storage'

declare module 'axios' {
  interface AxiosRequestConfig {
    skipGlobalErrorToast?: boolean
  }
}

const api = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL,
  headers: {
    'Content-Type': 'application/json',
    ...(process.env.NEXT_PUBLIC_CLIENT_ID && {
      'X-Client-ID': process.env.NEXT_PUBLIC_CLIENT_ID,
    }),
  },
})

let authExpired = false

export class AuthExpiredError extends Error {
  constructor(message = 'Sessão expirada') {
    super(message)
    this.name = 'AuthExpiredError'
  }
}

api.interceptors.request.use((config) => {
  if (typeof window !== 'undefined') {
    const token = getAccessToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
  }
  return config
})

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.config?.skipGlobalErrorToast) {
      return Promise.reject(error)
    }

    if (error?.response) {
      const status = error.response.status
      const data = error.response.data

      if (status === 401) {
        if (!authExpired) {
          authExpired = true
          clearAuthStorage()
          triggerLogoutHandler()
        }

        if (error instanceof Error) {
          ; (error as Error & { isAuthExpired?: boolean }).isAuthExpired = true
        }
      }

      if (status === 403) {
        toast.error(data?.message || 'Acesso negado')
      }

      if (status === 409) {
        toast.error(data?.message || 'Conflito na requisição')
      }

      if (status === 422) {
        toast.error(data?.message || 'Dados inválidos')
      }

      if (status === 400) {
        toast.error(data?.message || 'Requisição inválida')
      }

      if (status === 404) {
        toast.error(data?.message || 'Recurso não encontrado')
      }

      if (status >= 500) {
        toast.error('Erro interno do servidor')
      }
    }
    return Promise.reject(error)
  }
)

export default api
